export const joinNames = (name, lastName) => {
    const fullName = `${name}${lastName ? ` ${lastName}` : ''}`

    return fullName
}
